export default [
  {
    header: "აპლიკაციის მართვა",
  },
  {
    title: "TB დაწესებულება",
    route: "institutions",
    icon: "MapPinIcon",
  },
  {
    title: "ანგარიშები",
    route: "accounts",
    icon: "UserIcon",
  },
  {
    title: "ცვლადები",
    route: "variables",
    icon: "FileTextIcon",
  },
  {
    title: "სტატისტიკა",
    route: "statistics",
    icon: "BarChartIcon",
  },
]
